export interface GameplayStorage<T> {
  load(): T | undefined;
  save(value: T): void;
}

export class BrowserGameplayStorage<T> implements GameplayStorage<T> {
  constructor(private readonly key: string) {}

  load(): T | undefined {
    if (typeof window === 'undefined' || !window.localStorage) return undefined;
    const raw = window.localStorage.getItem(this.key);
    if (!raw) return undefined;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return undefined;
    }
  }

  save(value: T): void {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.setItem(this.key, JSON.stringify(value));
  }
}

export class MemoryGameplayStorage<T> implements GameplayStorage<T> {
  private value: T | undefined;

  load(): T | undefined {
    return this.value;
  }

  save(value: T): void {
    this.value = value;
  }
}
